import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/@bytel/product-wall/dist/product-wall.css");
;
import(/* webpackMode: "eager", webpackExports: ["SSIBlock"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/components/ssi-block.tsx");
